/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs */

const en__field__enum_schoolname_berufliche_schulen_gross_gerau5 = /** @type {(inputs: _Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groß-Gerau`)
};

const de__field__enum_schoolname_berufliche_schulen_gross_gerau5 = /** @type {(inputs: _Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufliche Schulen Groß-Gerau`)
};

/**
* | output |
* | --- |
* | "Groß-Gerau" |
*
* @param {_Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_berufliche_schulen_gross_gerau5 = /** @type {((inputs?: _Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Berufliche_Schulen_Gross_Gerau5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_berufliche_schulen_gross_gerau5(inputs)
	return de__field__enum_schoolname_berufliche_schulen_gross_gerau5(inputs)
});
export { _field__enum_schoolname_berufliche_schulen_gross_gerau5 as "_field__enum_schoolName_Berufliche_Schulen_Gross_Gerau" }